import React from 'react';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { PartiesTab } from './partiesTab/PartiesTab';
import { CoverWrapper } from '../../../../ui-toolkit/components/Cover/CoverWrapper';
import { OrderDataTab } from './summaryTab/OrderDataTab';
import { OtherTab } from './otherTab/OtherTab';
import { Summary } from '../../../shared/Summary/Summary';
import { TabProps } from '../../../shared/Summary/summaryContext';
import { eInternalOrderStatus } from '../../../../ui-toolkit/enums/eInternalOrderStatus';

export const SummaryContainer: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const isCancelled = data.orderInformation.status === eInternalOrderStatus.cancelled;

  return (
    <CoverWrapper showCover={isCancelled} clickThrough>
      <Summary title={'Order Information'} tabData={orderOverviewSummaryTabs}>
        <OrderDataTab />
        <PartiesTab />
        <OtherTab />
      </Summary>
    </CoverWrapper>
  );
};

const orderOverviewSummaryTabs: TabProps[] = [
  { label: 'summary', title: 'Summary', placeholder: 'Search summary order information' },
  { label: 'parties', title: 'Parties', placeholder: 'Search parties order information', callback: () => true },
  { label: 'other', title: 'Other', placeholder: 'Search other order information' },
];
